"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.configDefaults = void 0;

var _nuiConfig = _interopRequireDefault(require("@concur/nui-config"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://concur.gitbooks.io/nui/content/nui-config/introduction.html
var configDefaults = {
  nui: {
    branch: {
      value: 'appcenter',
      clientExposed: true
    },
    baseUrl: {
      value: '/nui/appcenter',
      clientExposed: true
    }
  },
  appcenterAPIBase: {
    client: {
      value: 'https://www-rqa3.api.nonprod.cnqr.tech/appcenter',
      clientExposed: true
    },
    server: {
      value: 'https://rqa3.api.nonprod.cnqr.tech/appcenter',
      clientExposed: false
    }
  },
  CTEUrl: {
    value: 'https://msprqa3.concurtech.net',
    clientExposed: true
  },
  enrollModalBase: {
    value: 'http://localhost',
    clientExposed: true
  },
  port: 3000,
  logger: {
    category: 'Web-API'
  }
};
exports.configDefaults = configDefaults;

var _default = (0, _nuiConfig.default)(configDefaults);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/config.js
// module id = 13
// module chunks = 0